import { render, staticRenderFns } from "./EditRecepcionistAdmin.vue?vue&type=template&id=7d88ed4c&scoped=true&"
import script from "./EditRecepcionistAdmin.vue?vue&type=script&lang=ts&"
export * from "./EditRecepcionistAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./EditRecepcionistAdmin.vue?vue&type=style&index=0&id=7d88ed4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d88ed4c",
  null
  
)

export default component.exports